import axiosClient from '../api/AxiosConfig';

export const NoteService = {
    GetNote: async () => {
        return (await axiosClient.get('/notes')).data;
    },
    GetNoteId: async (id) => {
        return (await axiosClient.get(`/notes/${id}`)).data;
    },
    EditNode: async (id, data) => {
        return (await axiosClient.put(`/notes/${id}`, data)).data;
    },
    CreateNote: async (data) => {
        return (await axiosClient.post(`/notes`, data)).data;
    },
    DeleteNote: async (id) => {
        return (await axiosClient.delete(`/notes/${id}`)).data;
    },
}